<app-split-pane
  storageKey="split.project"
  [initialLeftRatio]="0.7"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    <app-split-pane-vertical storageKey="split.project.left" [initialTopRatio]="0.7">
      <ng-container top>
        <app-chat [suggestions]="projectSuggestions" [context]="projectContext" placeholder="Ask about project state..."></app-chat>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="project.chat"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.project.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="page-workspace">
          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h2 class="h4 mb-1">Project State</h2>
            <p class="text-muted mb-3">Track delivery progress and quickly surface risk for active milestones.</p>
            <h3 class="h5 mb-3">Delivery State Check</h3>
            <div class="row g-3">
              <div class="col-md-4">
                <label class="form-label">Milestone</label>
                <input class="form-control" [(ngModel)]="projectDraft.milestone" placeholder="e.g. MVP release" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Owner</label>
                <input class="form-control" [(ngModel)]="projectDraft.owner" placeholder="e.g. Delivery lead" />
              </div>
              <div class="col-md-4">
                <label class="form-label">Status</label>
                <select class="form-select" [(ngModel)]="projectDraft.status">
                  <option value="">Select status...</option>
                  @for (option of statusOptions; track option) {
                    <option [value]="option">{{ option }}</option>
                  }
                </select>
              </div>
              <div class="col-12">
                <label class="form-label">Risk notes</label>
                <textarea class="form-control" rows="3" [(ngModel)]="projectDraft.riskNotes" placeholder="Dependencies, blockers, and mitigation..."></textarea>
              </div>
            </div>
            <div class="mt-3">
              <button class="btn btn-primary" type="button" [disabled]="evaluatingState" (click)="evaluateProjectState()">
                @if (evaluatingState) {
                  <span class="spinner-border spinner-border-sm me-2"></span>
                  Evaluating...
                } @else {
                  Evaluate Project State
                }
              </button>
            </div>
            @if (projectError) {
              <div class="alert alert-danger mt-3 mb-0">{{ projectError }}</div>
            }
            @if (projectSuccess) {
              <div class="alert alert-success mt-3 mb-0">{{ projectSuccess }}</div>
            }
          </section>

          <section class="card shadow-sm border-0 p-3 p-md-4">
            <h3 class="h5 mb-3">State Summary</h3>
            @if (!hasEvaluatedState) {
              <div class="small text-muted">No state check yet. Evaluate project state to populate summary.</div>
            } @else {
              <div class="summary-grid">
                <article class="summary-card">
                  <div class="summary-label">Milestone</div>
                  <div class="summary-value">{{ projectDraft.milestone }}</div>
                </article>
                <article class="summary-card">
                  <div class="summary-label">Owner</div>
                  <div class="summary-value">{{ projectDraft.owner }}</div>
                </article>
                <article class="summary-card">
                  <div class="summary-label">Status</div>
                  <div class="summary-value">{{ projectDraft.status }}</div>
                </article>
                <article class="summary-card summary-card--full">
                  <div class="summary-label">Risk notes</div>
                  <div class="summary-value">{{ projectDraft.riskNotes.trim() || 'No risk notes provided.' }}</div>
                </article>
              </div>
            }
          </section>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="project.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>
